<template lang="pug">
  TicketList(:ticket="ticket" create=false title="All User Ticket")
</template>

<script>
import taskService from '../service.js'
import TicketList from './TicketList'
import { mapGetters } from "vuex";

export default {

  data() {
    return {
      ticket: []
    }
  },
  components: {
    TicketList
  },
  mounted() {
    this.allUserDueTickets()
  },
  methods: {
    allUserDueTickets() {
      return taskService
      .allUserDueTickets()
      .then((response) => {
        console.log('all user ticket', response)
        this.ticket = response.data
      })
    },
  }
}
</script>

<style scoped>
</style>